// extracted by mini-css-extract-plugin
export var aggregationCell = "_2j-h";
export var aggregationRow = "_2j-g";
export var borderlessSpinnerContainer = "_2j-2";
export var closeIcon = "_2j-9";
export var expandIcon = "_2j-a";
export var expanded = "_2j-b";
export var filterDropdown = "_2j-c";
export var filterDropdownDivider = "_2j-7";
export var filterDropdownHeader = "_2j-f";
export var filterDropdownItem = "_2j-e";
export var filterDropdownModal = "_2j-d _2j-c";
export var filterItem = "_2j-6";
export var normalCellWithAdjustableBorder = "_2j-8";
export var pinButtonContainer = "_2j-i";
export var pinIcon = "_2j-j";
export var pinIconActive = "_2j-k";
export var spinner = "_2j-0";
export var spinnerContainer = "_2j-1";
export var tableContainer = "_2j-3";
export var tableContentInner = "_2j-5";
export var tableContentWrapper = "_2j-4";
export var viewButtonContainer = "_2j-l";